var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-ec-site-connect-pane"},[_c('mypage-ec-site-connect-section',{attrs:{"isConnectedBrowsingThisPage":_vm.isConnectedBrowsingThisPage},on:{"connectEc":_vm.connectEc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }